import { z } from 'zod';
import { isoDateTime, slugSchema } from './common';

export const formateurColorThemeSchema = z.enum(['vert', 'rouge', 'or']);
export type FormateurColorTheme = z.infer<typeof formateurColorThemeSchema>;

export const formateurInputSchema = z.object({
  slug: slugSchema,
  name: z.string().min(2),
  title: z.string(),
  bio: z.string(),
  city: z.string().min(1),
  photo: z.string().url().nullable().default(null),
  colorTheme: formateurColorThemeSchema.default('vert'),
  specialties: z.array(z.string()).default([]),
  formationIds: z.array(z.string()).default([]),
  /**
   * Display order on public lists (admin + Formateurs page + About). Range
   * 0–100. Smaller = shown first. Default 50 places newcomers in the middle,
   * preserving room to push someone higher or lower without renumbering.
   */
  displayOrder: z.number().int().min(0).max(100).default(50),
  /**
   * Public-facing contact / social links. All optional. Stored as loose
   * strings (not `.url()`) so admins can paste handles like `linkedin.com/in/x`
   * — the public component normalises to a usable href at render time.
   */
  linkedinUrl: z.string().max(300).optional(),
  instagramUrl: z.string().max(300).optional(),
  facebookUrl: z.string().max(300).optional(),
  tiktokUrl: z.string().max(300).optional(),
  email: z.string().max(160).optional(),
});
export type FormateurInput = z.infer<typeof formateurInputSchema>;

export const formateurSchema = formateurInputSchema.extend({
  id: z.string(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
});
export type Formateur = z.infer<typeof formateurSchema>;
